
interface LeftArrowInChipsFiltersProps {
    color: string;
    onClick: () => void;
    isVisibleOnHover?: boolean;
    additionalClassName?: string;
    svgAdditionalClassName?: string;
    minHeight?: string;
    isHorizontalList?: boolean;
    width?: string;
    height?: string;
    isArrowHidden?: boolean;
}

export const LeftArrowInChipsFilters = ({
    color, onClick,
    isVisibleOnHover = true,
    additionalClassName,
    svgAdditionalClassName,
    minHeight = '',
    isHorizontalList = false,
    width = '20px',
    height = '20px',
    isArrowHidden = false
}: LeftArrowInChipsFiltersProps) => {
    return (
        <>
            {isArrowHidden ? (
                <div className={`flex justify-center items-center cursor-pointer bg-transparent relative rounded-[4px]
                    ${isHorizontalList ? 'left-[0px] top-[0px]' : 'left-[26px] top-[0px]'} 
                    ${isVisibleOnHover ? 'opacity-70 hover:opacity-100' : 'opacity-0'} 
                    ${additionalClassName}
                    ${minHeight}`}
                    style={{
                        minWidth: `${width}`,
                        minHeight: `${height}`,
                        maxHeight: `${height}`,
                        zIndex: 110
                    }}
                />
            )
                : (
                    <div className={`flex justify-center items-center cursor-pointer bg-base090 relative rounded-[4px]
                ${isHorizontalList ? 'left-[0px] top-[0px]' : 'left-[26px] top-[0px]'} 
                ${isVisibleOnHover ? 'opacity-70 hover:opacity-100' : 'opacity-0'} 
                ${additionalClassName}
                ${minHeight}`}
                        onClick={onClick}
                        style={{
                            minWidth: `${width}`,
                            minHeight: `${height}`,
                            maxHeight: `${height}`,
                            zIndex: 110
                        }}
                    >
                        {isHorizontalList ? (
                            <svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M10.3349 0.279528C10.5934 0.602098 10.5428 1.07424 10.222 1.33409L1.99187 8L10.222 14.6659C10.5428 14.9258 10.5934 15.3979 10.3349 15.7205C10.0765 16.043 9.60691 16.0939 9.28609 15.834L1.05597 9.16813C0.31467 8.56772 0.31467 7.43228 1.05597 6.83187L9.28609 0.16596C9.60691 -0.0938876 10.0765 -0.0430414 10.3349 0.279528Z"
                                    fill={color}
                                />
                            </svg>
                        ) : (
                            <svg width="7" height="12" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={`${svgAdditionalClassName}`}>
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M9.83494 0.279528C10.0934 0.602098 10.0428 1.07424 9.72199 1.33409L1.49187 8L9.72198 14.6659C10.0428 14.9258 10.0934 15.3979 9.83494 15.7205C9.5765 16.043 9.10691 16.0939 8.78609 15.834L0.555974 9.16813C-0.18533 8.56772 -0.18533 7.43228 0.555974 6.83187L8.78609 0.16596C9.10691 -0.0938876 9.5765 -0.0430414 9.83494 0.279528Z"
                                    fill={color} />
                            </svg>
                        )}
                    </div>
                )}
        </>
    )
}
